export default __webpack_public_path__ + "static/media/failed.b411ae63.svg";